/**
 * UpgradePrompt.js
 * Reusable upgrade CTA shown when a user tries to access a gated feature.
 * Uses inline styles per project convention.
 */

import React from 'react';
import { useTheme } from '../context/ThemeContext';

const PLAN_LABELS = { starter: 'League', pro: 'Commissioner' };

export default function UpgradePrompt({ requiredPlan, feature, onNavigateToPricing }) {
  const { colors } = useTheme();
  const planName = PLAN_LABELS[requiredPlan] || requiredPlan;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '3rem 2rem',
      textAlign: 'center',
      gap: '1rem',
    }}>
      <div style={{ fontSize: '3rem' }}>🔒</div>
      <h2 style={{ margin: 0, fontSize: '1.4rem', fontWeight: '700', color: colors.text }}>
        {feature} requires the {planName} plan
      </h2>
      <p style={{ margin: 0, color: colors.textSecondary, maxWidth: 420, lineHeight: 1.5 }}>
        Upgrade to <strong>{planName}</strong> to unlock {feature} and more advanced league management tools.
      </p>
      {onNavigateToPricing && (
        <button
          onClick={onNavigateToPricing}
          style={{
            marginTop: '0.5rem',
            padding: '0.75rem 2rem',
            borderRadius: '8px',
            border: 'none',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: '#fff',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          View Pricing
        </button>
      )}
    </div>
  );
}
